/* global globalThis */
import { Component } from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import { Layout } from './screens/Layout';
import axios from "axios";
import { GetUserPrivUrl } from './utils/constants';
import './custom.css';
import './onetrust.css';
import './screen.css';
import CookiePolicy from './screens/cookie_policy/cookie_policy';
import PrivacyPolicy from './screens/privacy_policy/privacy_policy';
import TermsOfUse from './screens/terms_of_use/terms_of_use';
import { otInjectCookieScript } from './utils/onetrust';
import DashboardList from './screens/dashboard/dashboardList';
import LoadDashboard from './screens/dashboard/loadDashboard';
import DashboardAdd from './screens/dashboard/dashboardAdd';
import DashboardGroupAdd from './screens/dashboard_group/dashboardGroupAdd';
import DashboardGroupList from './screens/dashboard_group/dashboardGroupList';
import DashboardLog from './screens/dashboard_log/dashboardLog';
import ColliersUserManagementList from './screens/colliers_user_management/colliers_user_management_list';
import ColliersUserManagementManage from './screens/colliers_user_management/colliers_user_management_manage';
import ClientUserManagementList from './screens/client_user_management/client_user_management_list';
import ClientUserManagementManage from './screens/client_user_management/client_user_management_manage';
import AuditLog from './screens/audit_log/audit_log';
import Footer from './components/footer';
import Header from './components/header';
import { StyledEngineProvider } from "@mui/material";
import CountryList from './screens/country_admin/country_list';
import CountryManage from './screens/country_admin/country_manage';
import AccessDenied from './screens/AccessDenied';

export default class App extends Component {
    static displayName = App.name;

    constructor(props) {
        super(props);
        this.state = {
            authChecked: false
        };
    }

    handleUnauthenticated(isPublicPath, loginUrl) {
        localStorage.removeItem("userInfo");
        this.setState({ authChecked: true });
        if (!isPublicPath) {
            globalThis.location.href = loginUrl;
        }
    }

    componentDidMount() {
        otInjectCookieScript();
        const loginUrl = "/Login/KeyStone_Login";
        const publicPaths = ['/cookie-policy', '/privacy-policy', '/terms-of-use', '/access-denied'];
        const isPublicPath = publicPaths.includes(globalThis.location.pathname.toLowerCase());

        axios.get(GetUserPrivUrl)
            .then((response) => {
                if (!response?.data) {
                    this.handleUnauthenticated(isPublicPath, loginUrl);
                    console.error("Failed to fetch user privileges: No data found.");
                    return;
                }

                const { status, data } = response;

                if (status === 440 || status === 400 || status === 302 || data?.userID == null) {
                    this.handleUnauthenticated(isPublicPath, loginUrl);
                    return;
                }

                localStorage.setItem("userInfo", JSON.stringify(data));
                this.setState({ authChecked: true }, () => {
                    console.log("userData", response);

                    if (globalThis.location.pathname === loginUrl) {
                        globalThis.location.href = "/";
                    }
                });
            })
            .catch((error) => {
                this.handleUnauthenticated(isPublicPath, loginUrl);
                console.error("Error fetching user privileges:", error);
            });
    }

    render() {
        return (
            <StyledEngineProvider injectFirst>
                <Layout>
                    <div className="layout-top" key="layout-top">
                        <Header authChecked={this.state.authChecked} />
                        <div className="layout-top__content">
                            <div className="layout-grid-container">
                                {this.state.authChecked && (
                                    <Routes>
                                        {/* Error pages */}
                                        <Route path="/access-denied" element={<AccessDenied />} />
                                        {/* Legal / Policy Pages */}
                                        <Route path='/cookie-policy' element={<CookiePolicy />} />
                                        <Route path='/privacy-policy' element={<PrivacyPolicy />} />
                                        <Route path='/terms-of-use' element={<TermsOfUse />} />
                                        {/* Dashboard */}
                                        <Route path='/' element={<DashboardList />} />
                                        <Route path='/dashboard' element={<DashboardList />} />
                                        <Route path='/dashboardAdd' element={<DashboardAdd />} />
                                        <Route path='/loadDashboard' element={<LoadDashboard />} />
                                        <Route path='/loadDashboard/:code' element={<LoadDashboard />} />
                                        {/* Dashboard Group */}
                                        <Route path='/dashboard-group-add' element={<DashboardGroupAdd />} />
                                        <Route path='/dashboard-group' element={<DashboardGroupList />} />
                                        {/* Dashboard Log */}
                                        <Route path='/dashboard-log' element={<DashboardLog />} />
                                        {/* Colliers User */}
                                        <Route path='/colliers-user-management' element={<ColliersUserManagementList />} />
                                        <Route path='/colliers-user-management-manage' element={<ColliersUserManagementManage />} />
                                        {/* Client User */}
                                        <Route path='/client-user-management' element={<ClientUserManagementList />} />
                                        <Route path='/client-user-management-manage' element={<ClientUserManagementManage />} />
                                        {/* Audit Log */}
                                        <Route path='/audit-log' element={<AuditLog />} />
                                        <Route path='/audit-trail' element={<Navigate to='/audit-log' replace />} />
                                        {/* Country */}
                                        <Route path='/country' element={<CountryList />} />
                                        <Route path='/country-manage' element={<CountryManage />} />
                                    </Routes>
                                )}
                            </div>
                        </div>
                        <Footer />
                    </div>
                </Layout>
            </StyledEngineProvider>
        );
    }
}
